import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { DataGridCustomPagination } from "components/helper";
import { DatGridCustomToolbar } from "components/DataGridCustomToolbar";

const CustomDataGrid = (props) => {
  console.log("isEmpty: ", props);
  return (
    <DataGrid
      pagination
      pageSizeOptions={[50, 100]}
      pageSize={50}
      autoHeight
      density="compact"
      slots={{
        pagination: DataGridCustomPagination,
        toolbar: DatGridCustomToolbar,
      }}
      slotProps={{
        pagination: { myCustomProp: props },
        toolbar: { myCustomProp: props },
        loadingOverlay: {
          variant: "linear-progress",
          noRowsVariant: "linear-progress",
        },
      }}
      rows={props.rows}
      {...props}
    />
  );
};

export default CustomDataGrid;
